



















































































































































































































































































































































































import { Component, Mixins, Prop, Watch } from 'vue-property-decorator';
import { Button, FormItem, Input, Option, Select } from 'element-ui';
import NullableNumberInput from '@/components/element-ui/NullableNumberInput.vue';
import UtcDatePicker from '@/components/element-ui/UtcDatePicker.vue';

// sections
import HeaderSection from '@/components/documents/sections/Header.vue';
import FreightAndChargesSection from '@/components/documents/sections/FreightAndChargesInformation.vue';

// options
import { containerSizeOptions } from '@/constants/containerSizeOptions';
import { blTypeOptions } from '@/constants/blTypesOptions';
import { currencyOptions } from '@/constants/currencyOptions.ts';
import packagingOptions from '@/constants/packagingOptions';

// mixin
import carriers from '@/mixins/carrierOptions';
import partners from '@/mixins/partnerOptions.ts';
import places from '@/mixins/placeOptions';
import vessels from '@/mixins/vesselOptions';

// types
import {
  CurrencyEnum,
  ShipmentDocumentDataInput,
  ShipmentDocumentFields,
  TransportationCargoTypeEnum
} from '@/types/graphql/schemaTypes';

@Component({
  components: {
    HeaderSection,
    FreightAndChargesSection,
    NullableNumberInput,
    UtcDatePicker,
    'el-button': Button,
    'el-form-item': FormItem,
    'el-input': Input,
    'el-option': Option,
    'el-select': Select
  }
})
export default class ArrivalNotice extends Mixins(
  carriers,
  partners,
  places,
  vessels
) {
  @Prop() document!: ShipmentDocumentFields;
  @Prop({ default: false, type: Boolean }) isLoading!: boolean;

  formInput: ShipmentDocumentDataInput = {};
  emptyContainer = {
    containerNumber: null,
    sealNumber: null,
    containerType: null
  };

  // select options
  readonly blTypeOptions = blTypeOptions();
  readonly containerSizeOptions = containerSizeOptions();
  readonly currencyOptions = currencyOptions();
  readonly packagingOptions = packagingOptions();

  readonly TransportationCargoTypeEnum = TransportationCargoTypeEnum;

  created() {
    this.setFormInput();
    // disable auto select for place select
    this.autoSelect = false;
    // init transport type for place select
    this.transportationType = this.document.data.transportationType;
  }

  addContainer() {
    this.formInput.containerNumbers.push({ ...this.emptyContainer });
  }

  deleteContainer(index) {
    this.formInput.containerNumbers.splice(index, 1);
  }

  @Watch('document')
  setFormInput() {
    this.formInput = {
      // IMPORTANT re send readonly data
      shipmentCustomerRole: this.document.data?.shipmentCustomerRole,
      shipmentReference: this.document.data?.shipmentReference,
      transportCargoType: this.document.data?.transportCargoType,
      transportationType: this.document.data?.transportationType,
      // END IMPORTANT
      // Header information
      assignedOperator: this.document.data?.assignedOperator,
      issuanceDate: this.document.data?.issuanceDate,

      // Contact information
      shipmentShipperName: this.document.data?.shipmentShipperName,
      shipmentConsigneeName: this.document.data?.shipmentConsigneeName,
      shipmentNotifyName: this.document.data?.shipmentNotifyName,
      // Arrival information
      houseBlNumber: this.document.data?.houseBlNumber,
      blType: this.document.data?.blType,
      masterBlNumber: this.document.data?.masterBlNumber,
      portOfLoading: this.document.data?.portOfLoading,
      portOfDischarge: this.document.data?.portOfDischarge,
      deliveryLocation: this.document.data?.deliveryLocation,
      seaCarrier: this.document.data?.seaCarrier,
      vesselName: this.document.data?.vesselName,
      consolidator: this.document.data?.consolidator,
      voyageNumber: this.document.data?.voyageNumber,
      estimatedDateOfArrival: this.document.data?.estimatedDateOfArrival,
      freeTime: this.document.data?.freeTime,
      importDestinationAddress: this.document.data?.importDestinationAddress,
      importDestinationPhone: this.document.data?.importDestinationPhone,
      naccsCode: this.document.data?.naccsCode,
      // Description of goods
      descriptionOfGoods: this.document.data?.descriptionOfGoods,
      shippingMarks: this.document.data?.shippingMarks,
      containerNumbers: this.document.data?.containerNumbers.length
        ? [...this.document.data?.containerNumbers]
        : [{ ...this.emptyContainer }],
      packaging: this.document.data?.packaging,
      packagingQuantity: this.document.data?.packagingQuantity,
      grossWeight: this.document.data?.grossWeight,
      grossVolume: this.document.data?.grossVolume,
      remarks: this.document.data?.remarks,
      // Freight Charge information
      billItems: this.document.data?.billItems
        ? [...this.document.data?.billItems]
        : [],
      shipmentExchangeRate: this.document.data?.shipmentExchangeRate,
      finalCurrency: this.document.data?.finalCurrency || CurrencyEnum.JPY
    };
  }
}
